import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import type Item from 'owa-service/lib/contract/Item';

export default function shouldCreateItemPartViewState(
    item: Item,
    isDeleted: boolean,
    isLocal: boolean
): boolean {
    const userConfiguration = getUserConfiguration();
    const shouldHideDeletedItems = userConfiguration.UserOptions.HideDeletedItems;
    // No need to create view state for deleted drafts except for delete folder.
    // No need to create view state for deleted items when user setting has HideDeletedItems except for delete folder.
    return !!item && !((item.IsDraft || shouldHideDeletedItems) && isDeleted && !isLocal);
}
